import { render, staticRenderFns } from "./no_approve.vue?vue&type=template&id=15bf4b0e&scoped=true"
import script from "./no_approve.vue?vue&type=script&lang=js"
export * from "./no_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf4b0e",
  null
  
)

export default component.exports